import { render, staticRenderFns } from "./Mi.vue?vue&type=template&id=0140c9d3&"
var script = {}
import style0 from "./Mi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports